<template>
  <div class="table-container">
    <table class="table">
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index">
            <input
              v-model="this.header"
              :placeholder="'Header ' + (index + 1)"
              @change="updateTable"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">
            <input v-model="this.cell" @change="updateTable" />
          </td>
        </tr>
      </tbody>
      <td v-for="(cell, j) in row" :key="j">
  <input
    v-if="editable"
    v-model="row[j]"
    @input="$emit('update-table', { rowIndex: i, columnIndex: j, newValue: row[j] })"
  />
  <span v-else>{{ cell }}</span>
</td>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    headers: Array,
    rows: Array,
  },
  methods: {
    updateTable() {
      this.$emit("update-table", { headers: this.headers, rows: this.rows });
    },
  },
};
</script>

<style scoped>
.table {
  border-collapse: collapse;
  width: 100%;
}

.table th {
  background-color: #f2f2f2;
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.table td {
  border: 1px solid #ddd;
  padding: 8px;
}
</style>
